import Immutable from 'immutable'

export const HostedMailRecord = Immutable.Record({
  addresses: Immutable.Set(),
  domain: null,
  mailBoxes: 0,
}, 'ServiceHostedMail')

export default function createServiceHostedMail({
  addresses,
  mail_boxes,
  ...data
}) {
  return new HostedMailRecord({
    addresses: Immutable.Set(addresses),
    mailBoxes: parseInt(mail_boxes, 10),
    ...data,
  })
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/records/Service/HostedMail.js